import {FC} from 'react';
import {useField} from 'formik';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {Button} from '@tickchak/react-share/app';
import {TShow} from '../../../../../hooks/useShow';
import {RootState} from '../../../../../redux/store.type';
import PlusThin from '../../../../../assets/icons/PlusThin';
import getColor from '../../../../../functions/getColor';
import TicketRow from './TicketRow';
import * as css from './TicketsSection.css';

interface Props {
    onCreateTicket: TShow['open'];
}

const TicketsSection: FC<Props> = ({onCreateTicket}) => {
    const {t} = useTranslation('timetable');
    const [field, , helpers] = useField<number[]>('tids');
    const {tickets, ticketsIcon} = useSelector((state: RootState) => state.tickets);
    const currencySymbol = useSelector((state: RootState) => state.event.currencySymbol) || '₪';

    const toggle = (tid: number) => helpers.setValue(
        field.value.includes(tid) ? field.value.filter(id => id !== tid) : [...field.value, tid]
    );

    return (
        <css.wrap>
            <css.header>
                <css.headerTitle>{t('tabTickets')}</css.headerTitle>
                <css.headerSubtitle>{t('assignedTicketsSubtitle')}</css.headerSubtitle>
            </css.header>

            <css.list>
                {tickets?.length
                    ? tickets.map((tk: any) => (
                        <TicketRow
                            key={tk.tid}
                            ticket={tk}
                            color={tk.color || getColor(null, tickets)}
                            checked={field.value.includes(tk.tid)}
                            ticketsIcon={ticketsIcon}
                            currencySymbol={currencySymbol}
                            onToggle={() => toggle(tk.tid)}
                        />
                    ))
                    : <css.empty>{t('noEventTickets')}</css.empty>}
            </css.list>

            <css.addBtnWrap>
                <Button variant="neutral" size="category" iconEnd={<PlusThin color="black" />} onClick={onCreateTicket}>
                    {t('createNewTicket')}
                </Button>
            </css.addBtnWrap>
        </css.wrap>
    );
};

export default TicketsSection;
